import { useSelector } from "react-redux";
export const useGetSelectedDealFundId = () => {
    const selectedFundId = useSelector((state) => state.currentDashboard.dashboardOptions?.selectedFundId);
    const [firstDeal] = useSelector((state) => state.entities.Asset?.[state.currentDashboard.currentEntityId]?.deals) || [];
    if (selectedFundId) {
        return selectedFundId;
    }
    return firstDeal?.fundId;
};
